import {
  League,
  LeagueTable,
  LeagueTeam,
  LeagueTeamMember,
  LeagueTypeCode,
  Round,
  RoundMatch,
  RoundWithMatches,
  Scorer,
  SportEvent,
  Team,
  TeamMember
} from "@/models";
import { Module } from "vuex";
import { actions, mutations } from ".";
import { RootState } from "..";

export interface SportEventState {
  sportEvent?: SportEvent;
  leagues: League[];
  teams: (LeagueTeam & { isLoading?: boolean })[];
  registeredTeamMembers: LeagueTeamMember[];
  selectedLeagueId?: number;
  leagueTable: LeagueTable;
  topScorers: Scorer[];
  rounds: Round[] | RoundWithMatches[];
  selectedRoundId?: number;
  roundMatches: RoundMatch[];
  userTeams: Team[];
  userTeamMembers: TeamMember[];
}

export const getInitialState = (): SportEventState => ({
  sportEvent: undefined,
  teams: [],
  registeredTeamMembers: [],
  leagues: [],
  selectedLeagueId: undefined,
  leagueTable: [],
  topScorers: [],
  rounds: [],
  selectedRoundId: undefined,
  roundMatches: [],
  userTeams: [],
  userTeamMembers: []
});

export const namespaceSportEvent = "sportEvent";

export const sportEventModule: Module<SportEventState, RootState> = {
  namespaced: true,
  state: getInitialState(),
  actions,
  mutations,
  getters: {
    selectedLeague: state => {
      return state.leagues.find(league => league.id === state.selectedLeagueId);
    },
    isLeagueCupPlayoff: (_, getters) => getters.selectedLeague && getters.selectedLeague.league_type.code === LeagueTypeCode.CupPlayoff,
    selectedRound: state => {
      return state.rounds.find(round => round.id === state.selectedRoundId);
    },
    isEventStarted: state => {
      return state.sportEvent ? state.sportEvent.status.code !== "registration" : false;
    },
    isRegistrationOpen: state => {
      return state.sportEvent
        ? state.sportEvent.status.code === "registration" && state.sportEvent.registration_status.code === "apply"
        : false;
    },
    topScorersSorted: state => (state.topScorers ? state.topScorers.sort((a, b) => b.goals - a.goals).slice(0, 10) : [])
  }
};

export * from "./sport-event.actions";
export * from "./sport-event.mutations";
